module.exports = __webpack_public_path__ + "img/icon-bling.e5ecd1a8.svg";